import React, {useContext} from 'react'
import {
    TableRow,
    TableHeaderCell,
    TableHeader,
    TableCell,
    TableBody,
    Table, Label, TableFooter, Dropdown, Button, Icon, Pagination,
} from 'semantic-ui-react'
import { IRequestReview } from '../../../../App/models/RequestReview';
import Moment from "react-moment";
import ReadOnly from './Options/ReadOnly';
import { RootStoreContext } from '../../../../App/stores/RootStore'
import {observer} from "mobx-react-lite";

const pagingOptions = [
    {
        text: '1',
        value: 1
    },
    {
        text: '5',
        value: 5
    },
    {
        text: '10',
        value: 10
    },
    {
        text: '25',
        value: 25
    },
    {
        text: '50',
        value: 50
    }
]


const RequestReviewListTable: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const {requestReviews, requestReviewCount, limit,  setLimit, page, setPage, loadTableRequestReviews, totalPages} = rootStore.requestReviewStore;
    const { openModal } = rootStore.modalStore;


    const handleGetNext = async (page:number) => {
        // setLoadingNext(true);
        setPage(page);
        await loadTableRequestReviews();//.then(() => setLoadingNext(false))
    }

    // const toggleSort = async (column:string)=>{
    //     setSort(sortOrder==='ascending'?'descending':'ascending', column)
    //     await loadTableRequestReviews()
    // }

    return (
        <Table sortable celled >
            <TableHeader>
                <TableRow>
                    <TableHeaderCell width={1}>

                    </TableHeaderCell>
                    <TableHeaderCell

                        // sorted={sortBy === 'requestCaseID' ? sortOrder : undefined}
                        // onClick={async () => {
                        //     await toggleSort('Request.RequestCaseID')
                        // }
                        // }
                    >
                        Case Id
                    </TableHeaderCell>


                    <TableHeaderCell
                        // sorted={sortBy === 'provider' ? sortOrder : undefined}
                        // onClick={async () => {
                        //     await toggleSort('request.provider')
                        //     }
                        // }
                    >
                        Provider
                    </TableHeaderCell>
                    <TableHeaderCell
                        // sorted={sortBy === 'serviceType' ? sortOrder : undefined}
                        // onClick={async () => {
                        //     await toggleSort('request.serviceType')
                        // }
                        // }
                    >
                        Service Type
                    </TableHeaderCell>
                    <TableHeaderCell
                        // sorted={sortBy === 'transactionType' ? sortOrder : undefined}
                        // onClick={async () => {
                        //     await toggleSort('request.transactionType')
                        // }
                        // }
                    >
                        Transaction Type
                    </TableHeaderCell>
                    <TableHeaderCell
                        // sorted={sortBy === 'registrationRequestId' ? sortOrder : undefined}
                        // onClick={async () => {
                        //     await toggleSort('request.registrationRequestId')
                        // }
                        // }
                    >
                        Registration Request Id
                    </TableHeaderCell>
                    <TableHeaderCell
                        // sorted={sortBy === 'requestDate' ? sortOrder : undefined}
                        // onClick={async () => {
                        //     await toggleSort('request.requestDate')
                        // }
                        // }
                    >
                        Request Age
                    </TableHeaderCell>
                    <TableHeaderCell
                        // sorted={sortBy === 'serviceId' ? sortOrder : undefined}
                        // onClick={async () => {
                        //     await toggleSort('request.serviceId')
                        // }
                        // }
                    >
                        Service Id
                    </TableHeaderCell>
                    <TableHeaderCell>
                        status
                    </TableHeaderCell>
                    <TableHeaderCell>
                        recommendation By
                    </TableHeaderCell>
                    <TableHeaderCell>
                        decision By
                    </TableHeaderCell>
                    {/*<TableHeaderCell>*/}
                    {/*    Current Reviewer*/}
                    {/*</TableHeaderCell>*/}
                    <TableHeaderCell
                        // sorted={sortBy === 'documentDate' ? sortOrder : undefined}
                        // onClick={async () => {
                        //     await toggleSort('request.documentDate')
                        // }
                        // }
                    >
                        document Date
                    </TableHeaderCell>

                </TableRow>
            </TableHeader>
            <TableBody>
                {requestReviews.map((requestReview: IRequestReview) => (
                    <TableRow key={requestReview.id}>
                        <TableCell>
                            {
                                requestReview.reviewEnd !== null ?
                                    <Button
                                        positive
                                        onClick={() => openModal(<ReadOnly RequestReviewId={requestReview.id} />)} >
                                        View in Read Only Mode
                                        <Icon name="arrow alternate circle right" />
                                    </Button> : ""
                            }
                        </TableCell>
                        <TableCell>
                            {requestReview.requestCaseID}
                            {(
                                requestReview.spanishRequest ?
                                    <Label color="yellow">Spanish</Label> :
                                    ""
                            )}
                        </TableCell>
                        <TableCell>{requestReview.provider}</TableCell>
                        <TableCell>{requestReview.serviceType}</TableCell>
                        <TableCell>{requestReview.transactionType}</TableCell>
                        <TableCell>{requestReview.registrationRequestID}</TableCell>
                        <TableCell>{requestReview.age + " hours"}</TableCell>
                        <TableCell>{requestReview.tdn}</TableCell>
                        <TableCell>{requestReview.status}</TableCell>
                        <TableCell>{requestReview.recommendationBy}</TableCell>
                        <TableCell>{requestReview.decisionBy}</TableCell>
                        {/*<TableCell>{requestReview.currentRequestReviewerName}</TableCell>*/}
                        <TableCell><Moment format={'MMM D YYYY'} date={requestReview.documentDate} /></TableCell>
                    </TableRow>

                ))}

            </TableBody>
            <TableFooter fullWidth>
                <TableRow >
                    <TableHeaderCell >
                        <Label> total records: {requestReviewCount}</Label>
                        <Label>Records per Page</Label>

                        <Dropdown
                            className='icon'
                            item
                            placeholder=''
                            clearable={false}
                            fluid={ false}
                            selection
                            options={pagingOptions}
                            onChange={async (pageOption) => {
                                setPage(0)
                                setLimit(parseInt(pageOption.currentTarget.innerText))
                                await loadTableRequestReviews()
                            }}
                            value={limit}

                        />
                    </TableHeaderCell>

                    <TableHeaderCell colSpan='10'>
                        <Pagination
                            defaultActivePage={page}
                            onPageChange={async (e,d)=>{
                                let newPage = d.activePage as number
                                await handleGetNext(newPage-1)
                            }}
                            ellipsisItem={{ content: <Icon name='ellipsis horizontal' />, icon: true }}
                            firstItem={{ content: <Icon name='angle double left' />, icon: true }}
                            lastItem={{ content: <Icon name='angle double right' />, icon: true }}
                            prevItem={{ content: <Icon name='angle left' />, icon: true }}
                            nextItem={{ content: <Icon name='angle right' />, icon: true }}
                            totalPages={totalPages}
                        />

                    </TableHeaderCell>
                </TableRow>
            </TableFooter>
        </Table>
    )
}
export default observer(RequestReviewListTable)